module.exports = __webpack_public_path__ + "img/live.84330eae.gif";